module.exports = __webpack_public_path__ + "img/state3.87b9abbb.png";